<template>
  <div class="home">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 col-xl-9 col-xl-offset-3 col-lg-9 col-lg-offset-3">
          <div class="content">
            <a :href="labels.URL_TERUG_NAAR_SITE" class="backlink">{{ labels.LINK_TERUG_NAAR_SITE }}</a>
            <header class="content__header">
              <h1>{{ labels.TITEL }}</h1>
              <div class="input input--search">
                <div class="input__control-group">
                  <input
                    placeholder="Zoek op initiatief, plaatsnaam of trefwoord"
                    type="text"
                    id="search_fat"
                    title="Zoeken"
                    aria-labelledby="search_button"
                    aria-describedby="search_hint"
                    class="input__control  input__control--search"
                    v-on:keyup.enter="filter"
                    v-model="zoekItem"
                  />
                  <button
                    class="btn btn--icon"
                    id="search_button"
                    title="Zoeken"
                    @click="filter"
                  >
                    <i class="icon icon-magnifier" role="presentation" />
                  </button>
                </div>
              </div>
              <div class="hidden-lg-up">
              	<button v-on:click="isHidden = !isHidden" class="btn" v-html="isHidden ? 'Toon filters' : 'Verberg filters'"></button>
            	</div>
            </header>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-3 col-lg-3" :class="{ 'hidden-md-down': isHidden, 'hidden-lg-up': !isHidden }">
          <div class="spacing-inner-m">   
            <fieldset class="input filter" id="postcode">
              <legend class="filter__title">{{ labels.VOEDINGSGEBIED_TITEL }}</legend>
              <p>{{ labels.VOEDINGSGEBIED_TEKST }}</p>
              <label class="input__label" for="search_pcode">Postcode</label>
              <span class="input__hint screenreader-only" id="search_hint">{{ labels.VOEDINGSGEBIED_INVULTIP }}</span>
              <div class="input__control-group">
                  <input
                    placeholder="9999"
                    type="number"
                    id="search_pcode"
                    title="Zoeken"
                    maxlength="4"
                    aria-labelledby="search_button_voedingsgebied"
                    aria-describedby="search_hint"
                    class="input__control  input__control--search"
                    oninput="(this.value.length > this.maxLength) ? this.value = this.value.slice(0, this.maxLength) : '';"
                    onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                    v-on:keyup.enter="filterVoedingsgebied"
                    v-model="zoekVoedingsgebied"
                  />
                  <button
                    class="btn btn--icon"
                    id="search_button_voedingsgebied"
                    title="Zoeken"
                    @click="filterVoedingsgebied"
                  >
                    <i class="icon icon-magnifier" role="presentation" />
                  </button>
                </div>
            </fieldset>

            <fieldset class="input filter" id="jaren" v-if="$store.state.years && $store.state.years.length > 1">
              <legend class="filter__title">{{ labels.STARTJAAR }}</legend>
                <div class="input__group input__group--compact input__group--checkbox"
                  v-for="jaar in $store.state.years"
                  v-bind:key="jaar">
                  <input
                    class="input__control input__control--checkbox"
                    type="checkbox"
                    :id="jaar"
                    :value="jaar"
                    v-model="$store.state.selectedYears"
                    @change="$refs.pagination.onClickFirstPage();"
                  />
                  <label
                    class="input__label input__label--checkbox"
                    :for="jaar"
                  >
                    {{ jaar }}
                  </label>
                </div>
            </fieldset>

            <fieldset class="input filter" id="sector">
              <legend class="filter__title">{{ labels.SECTOR }}</legend>
              
              <div class="input__group input__group--compact input__group--radio">
                <input class="input__control input__control--radio" type="radio" id="select-all" value="" name="sector-filter" v-model="checkedSector" @change="filter" />
                <label class="input__label input__label--radio" for="select-all">
                  Alles
                </label>
              </div>

              <div
                class="input__group input__group--compact input__group--radio"
                v-for="sector in initiatief.sectoren"
                v-bind:key="sector.id">
                <input
                  class="input__control input__control--radio"
                  type="radio"
                  name="sector-filter"
                  :id="sector.id"
                  :value="sector.id"
                  v-model="checkedSector"
                  @change="filter"
                />
                <label
                  class="input__label input__label--radio"
                  :for="sector.id"
                >
                  {{ sector.description }}
                </label>
              </div>

              <ul>
                <div class="input__group input__group--compact input__group--checkbox"
                  v-for="onderwijssoort in initiatief.vo_typen"
                  v-bind:key="onderwijssoort.id">
                  <input
                    class="input__control input__control--checkbox"
                    type="checkbox"
                    :id="onderwijssoort.id"
                    :value="onderwijssoort.id"
                    v-model="checkedOnderwijssoort"
                    @change="filterCheckbox"
                  />
                  <label
                    class="input__label input__label--checkbox"
                    :for="onderwijssoort.id"
                  >
                    {{ onderwijssoort.description }}
                  </label>
                </div>
              </ul>
            </fieldset>
          </div>
        </div>

        <div class="col-xl-9 col-lg-9 col-md-12">
          <ListInitiatives class="paginate-list" :collection="pagedResult" :numberofrecords="filteredInitiatives.length" />
          <PaginationComponent ref="pagination"
            :total-pages="totalPages()"
            :total="filteredInitiatives.length"
            :per-page="resultsPerPage"
            :current-page="currentPage"
            @pagechanged="onPageChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { toonDescription } from "../mixins/toonDescription";
import PaginationComponent from "../components/pagination";
import ListInitiatives from "../components/ListInitiatives";
const sanitizeHtml = require('sanitize-html');

export default {
  name: "app",
  mixins: [toonDescription],
  computed: {
    ...mapGetters([
      "filteredInitiatives",
      "initiatives",
      "labels",
      "selectedSector",
      "pageNumber"
    ]),
    soortOnderwijs: function() {
      this.$store.commit("setSelectedSector", this.$route.query.soort);
      return this.$route.query.soort;
    }
  },
  created() {
    this.$trackPageView('Overzicht Initiatieven');
		this.$store.dispatch('FETCH_INITIATIVES');

    if(this.isDesktop()) {
     window.addEventListener('resize', ()=> this.isHidden = true)
    }
  },
  destroyed() {
    if(this.isDesktop()) {
     window.removeEventListener('resize', ()=> this.isHidden = true)
    }
  },
  data: function() {
    return {
      resultsPerPage: 10,
      checkedOnderwijssoort: [],
      checkedSector: "",
      oldSector: "",
      pagedResult: [],
      zoekresult: [],
      arrSectoren: [],
      zoekItem: "",
      zoekVoedingsgebied: "",
      paginate: ["items"],
      currentPage: 1,
      isCheckAll: false,
      isHidden: true
    };
  },
  components: {
    PaginationComponent,
    ListInitiatives
  },
  watch: {
    filteredInitiatives(value) {
        this.onPageChange(this.pageNumber);
    },
  },
  updated() {
    this.tooltipInit();
  },
  methods: {
    isDesktop(){
        return window.matchMedia('only screen and (min-width: 768px)').matches
    },
    totalPages: function() {
      return Math.ceil(this.filteredInitiatives.length / this.resultsPerPage);
    },
    filterCheckbox() {
        this.$store.commit("setSelectedSector", "VO");
        this.checkedSector = "VO";
        this.filter();
    },

    filter() {
      let searchText = sanitizeHtml(this.zoekItem).trim().normalize('NFD').replace(/\p{Diacritic}/gu, "");
      if (this.$matomo != undefined){
          this.$matomo.trackEvent("Initiatief-scholen", "zoeken", searchText);
      }
      // zoek op invulveld
      this.zoekresult = this.initiatives.filter(
        initiatief => 
          this.findMatchInString(initiatief.naam.normalize('NFD').replace(/\p{Diacritic}/gu, ""), searchText) ||
          this.findMatchInString(initiatief.plaatsnaam.normalize('NFD').replace(/\p{Diacritic}/gu, ""), searchText) ||
          this.findMatchInString(initiatief.toelichting.normalize('NFD').replace(/\p{Diacritic}/gu, ""), searchText) ||
          (initiatief.plaatsnaam_alternatief && this.findMatchInString(initiatief.plaatsnaam_alternatief.normalize('NFD').replace(/\p{Diacritic}/gu, ""), searchText))
      );
      
      // zoek op sectoren
      if (this.checkedSector.length == 0) {
        this.checkedOnderwijssoort = this.oldSector.length > 0 ? []: this.checkedOnderwijssoort;
        
        if (this.checkedOnderwijssoort.length) {
          this.zoekresult = this.zoekresult.filter(initiatief =>
            initiatief.soortOnderwijs.some(soort => this.checkedOnderwijssoort.includes(soort.soortOnderwijs))
          );    
        }
      }

      if (this.checkedSector.length > 0) {
        this.$store.commit("setSelectedSector", this.checkedSector);

        if (this.checkedSector == "PO"){
          
          if (this.checkedOnderwijssoort.length > 0) {
            this.checkAll();
          }

          else {
            this.isCheckAll = false;      
          }
        }

        if(this.oldSector === "VO") {
          this.checkedOnderwijssoort = this.oldSector.length == 0 ? []: this.checkedOnderwijssoort;
        }      
        
        if (this.checkedOnderwijssoort.length == 0) {
        this.zoekresult = this.zoekresult.filter(initiatieven => this.checkedSector.includes(initiatieven.sector));
        }

        if (this.checkedSector == "VO" && this.checkedOnderwijssoort.length == 0 && this.oldSector != 'VO') { 
           this.checkAll(); 

          }
        }

        if (this.checkedOnderwijssoort.length) {
            this.zoekresult = this.zoekresult.filter(initiatief =>
            initiatief.soortOnderwijs.some(soort => this.checkedOnderwijssoort.includes(soort.soortOnderwijs))
          );      
        }

       if(this.checkedOnderwijssoort.length > 0) {
            this.$store.commit("setSelectedSector", "VO");
            this.checkedSector = "VO" 
            this.isCheckAll = false;
        }

        if (this.checkedOnderwijssoort.length == 0 && this.checkedSector === "VO") {
            this.zoekresult = [];
        }

      this.oldSector = this.checkedSector;

	  // zoek op postcode
	  this.zoekresult = this.zoekVoedingsgebied.trim() !== ""
	  	? this.zoekresult = this.zoekresult.filter(initiatief =>
            (initiatief.Voedingsgebied.some(soort => this.zoekVoedingsgebied.includes(soort.postcodeCijfers)) || this.zoekVoedingsgebied === initiatief.postcodeCijfers) &&
			initiatief.belangstellingsmetingOuderverklaring === true &&
			(initiatief.datumtijdAanvraagIngediend == undefined || 
			initiatief.datumtijdAanvraagIngediend == "") &&
			initiatief.StatusExtern.statusExtern.toLowerCase() != 'ingetrokken'
          )
		: this.zoekresult;

      this.$store.commit("setFilteredInitiatives", this.zoekresult);
      this.$refs.pagination.onClickFirstPage();
    },
    findMatchInString: function(stringToSearch, searchFor){
      let findItem = sanitizeHtml(encodeURIComponent(searchFor)).toLowerCase().split("%20");

      for (let i = 0; i < findItem.length; i++){
        if (!sanitizeHtml(stringToSearch).toLowerCase().includes(findItem[i])) {
          return false;
        }
      }
      return true;
    },

    filterVoedingsgebied: function() {
      if (this.$matomo != undefined){
        this.$matomo.trackEvent("Initiatief-scholen", "postcodezoeken", this.zoekVoedingsgebied);
      }
	  this.filter();
    },

    onPageChange(page) {  
      this.$store.commit("setPageNumber", page);
      this.currentPage = page;
      var startindex = (page-1) * this.resultsPerPage;
      var endIndex = startindex + this.resultsPerPage;
      this.pagedResult = this.filteredInitiatives.slice(startindex, endIndex);
    },
    
    checkAll: function(){
      if (this.checkedSector == "VO"){
        this.isCheckAll = true; 
      }
      else {
        this.isCheckAll = false;
      }
      this.checkedOnderwijssoort = [];
      if(this.isCheckAll){ 
        for (var key in this.initiatief.vo_typen) {
          this.checkedOnderwijssoort.push(this.initiatief.vo_typen[key].id);
        }
      }
    },
    tooltipInit(){

      if (window.System) {
        window.System.import('./libs/uno/dist/components/tooltip/tooltip.js')
        .then(module => {
          var tooltips = document.querySelectorAll('.icon-info');
          for (var i = 0; i < tooltips.length; i++) {
            new module.Tooltip(tooltips.item(i));
          }
        })
        .catch((err) => {
          // catch error for unit testing
        });
        }
    }
  }
};
</script>
